const inputLimits = {
  email: {
    max: 100,
  },
  message: {
    max: 200,
  },
  name: {
    max: 30,
  },
}

export default inputLimits
